import { Select, SelectOption } from '@amzn/meridian';
import type { DestinationUrlInput } from 'features/campaign/campaign.types';
import {
  DestinationUrlInputDisplay,
  newLinkTypeOptions,
} from 'features/traffic/campaigns/content/common-components/RefTaggedLinkEditor/link-type-and-link-type-value-utils';

type LinkTypeSelectProps = {
  onChange: (value: DestinationUrlInput) => void;
  value: DestinationUrlInput;
};

export const LinkTypeSelect = ({ onChange, value }: LinkTypeSelectProps) => (
  <Select label="Link type" onChange={onChange} value={value}>
    {newLinkTypeOptions.map((linkType) => (
      <SelectOption key={linkType} label={DestinationUrlInputDisplay[linkType]} value={linkType} />
    ))}
  </Select>
);
